<div class="fieldset-wrapper descriptive-text-wrap"
  [ngClass]="(questions?.mandatory && isMandatoryUpfront && questions.qsubtype != 1) ? 'isMandatory' : ''">
  <!-- <div *ngIf="questions?.hasMedia && questions?.QuestionMedias_1 != null" class="questionImageWrapper">
      <app-question-media [questionMedias]="questions?.QuestionMedias_1" [imageSize]="questions?.ImageSize" [isMobile]="isMobile"></app-question-media>
    </div>
<div *ngIf="questions?.hasImages && questions?.QuestionImages_1 != null" class="questionImageWrapper">
  <app-question-images [questionImages]="questions?.QuestionImages_1" [imageSize]="questions?.ImageSize" [isMobile]="isMobile"></app-question-images>
</div> -->
  <span *ngIf="(questions?.mandatory && isMandatoryUpfront && questions.qsubtype != 1)" class="screen-read-only">This
    Question is Required</span>
  <div *ngIf="questions?.QuestionImageAndMedia_1 != null" class="questionImageWrapper"
    [ngClass]="{'question-border': !isMobile}">
    <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_1"
      [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
    </app-question-image-and-media>
  </div>

  <fieldset>
    <!-- <legend class="comment-wrapper fl" [ngClass]="isRTL ? 'fr' : '' "  style="width: 100%;"> -->
    <legend class="comment-wrapper fl"
      [ngClass]="{'fr': isRTL,'question-border': questions.QuestionImageAndMedia_1 == null && !isMobile}"
      style="width: 100%;">
      <span *ngIf="isDisplayQno && questions?.qno > 0" class="question-no"><strong>{{questions?.qno}}.</strong></span>
      <span *ngIf="questions.piping" [ngClass]="{'question-text': questions.isOverAllStyleApplied,
      'question-text-nb': !questions.isOverAllStyleApplied,
      'comment-text' :  questions.qsubtype == 0,
      'captcha-text' :  questions.qsubtype == 1,
      'no-Qno':!isDisplayQno}" id="lbltitle_CM{{questions?.UniqueNumber}}" style="width: 100%;" tabindex="0">
        <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
        <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0"></span>
      </span>
      <span *ngIf="!questions.piping" [ngClass]="{'question-text': questions.isOverAllStyleApplied,
      'question-text-nb': !questions.isOverAllStyleApplied,
      'comment-text' :  questions.qsubtype == 0,
      'captcha-text' :  questions.qsubtype == 1,
      'no-Qno':!isDisplayQno}" id="lbltitle_CM{{questions?.UniqueNumber}}" style="width: 100%; display: block;"
        tabindex="0">
        <span [innerHTML]="questions?.qtitle | headerFooterHtml"></span>
        <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0"></span>
        <div *ngIf="questions?.hasMedia && questions?.MediaText != null && questions?.MediaText != ''"
          class="question-media-text">
          <span>[{{questions?.MediaText}}]</span>
        </div>
      </span>
    </legend>
    <div style="clear: both;"></div>
    <!-- <div *ngIf="questions?.hasMedia && questions?.QuestionMedias_2 != null" class="questionImageWrapper">
        <app-question-media [questionMedias]="questions?.QuestionMedias_2" [imageSize]="questions?.ImageSize" [isMobile]="isMobile"></app-question-media>
      </div>
    <div *ngIf="questions?.hasImages && questions?.QuestionImages_2 != null" class="questionImageWrapper">
      <app-question-images [questionImages]="questions?.QuestionImages_2" [imageSize]="questions?.ImageSize" [isMobile]="isMobile"></app-question-images>
    </div> -->

    <div *ngIf="questions?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
      <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_2"
        [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
      </app-question-image-and-media>
    </div>

  </fieldset>
  <div class="fieldset-wrapper-scroll-cont" *ngIf="questions.qsubtype == 1">
    <div class="div-scroll-btn"><span class="div-scroll-symbol"></span></div>
    <div class="fieldset-wrapper-scroll">
      <div style="display: table; width: 100%;">
        <div class="answer-option-wrapper" style="background-color: transparent; overflow: hidden;"
          [ngStyle]="{'max-width': isMobile? '300px' : 'auto'}">
          
          <ngx-recaptcha2 [hl]="isAnsSelectedLang"  (success)="resolved($event)" siteKey={{questions.dataSecretKey}} [theme]='theme'></ngx-recaptcha2>
          <ng-container *ngIf="isNewParticipation  && (surveyFormat == 1 || surveyFormat == 2)">
            <div class="ques-response-btn-div">
              <!-- <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn" (click)="gotoNextQuestion(questions,$event.target)"/> -->
              <button *ngIf="isNewParticipationButton && isAnsChange" type="button" class="ques-response-btn"
                (keyup.Space)="gotoNextQuestionKeyboard(questions,$event)"
                (click)="gotoNextQuestion(questions,$event.target)">{{newParticipationBtnText}}</button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isNewParticipation  && (surveyFormat == 1 || surveyFormat == 2) && questions.qsubtype != 1">
    <div class="ques-response-btn-div">
      <!-- <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn" (click)="gotoNextQuestion(questions,$event.target)"/> -->
      <button *ngIf="isNewParticipationButton && isqtitlelarge" type="button" class="ques-response-btn"
        (keyup.Space)="gotoNextQuestionKeyboard(questions,$event)"
        (click)="gotoNextQuestion(questions,$event.target)">{{newParticipationBtnText}}</button>
    </div>
  </ng-container>
</div>